import { setBusqueda } from '../../actions/articulos'
import { setFamiliaSeleccionada } from '../../actions/familias'
import { anadirFiltro, getFiltros, limpiarFiltros } from '../../actions/filtros'
import '../../css/articulos.css'
import ArticulosFiltros from './ArticulosFiltros'
import Buscador from './Buscador'
import BuscadorAvanzado from './BuscadorAvanzado'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useMemo, useState } from 'react'
import ListadoArticulos from './ListadoArticulos'
import { useNavigate } from 'react-router'
import { cargarParametros } from '../../helpers/funciones'
import FamiliasMenu from './FamiliasMenu'

let estadistico_url
let familia_url
let descrip_url
const parametros_usados = ['bus_avanz']

const Articulos = () => {
  const filtros = useSelector(state => state.articulos.filtros)
  const filtros_claves_estadisticas = useSelector(
    state => state.articulos.filtros_claves_estadisticas,
  )
  const parametros_state = useSelector(state => state.portal.portal.parametros_ecom)
  const ecom_parametros = useMemo(() => {
    return cargarParametros(parametros_usados, parametros_state, 'GEN')
  }, [parametros_state])

  const [buscador, setBuscador] = useState('basico')

  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    if (window.location.pathname !== '/articulos') {
      navigate('/articulos')
    }

    if (estadistico_url && familia_url && descrip_url) {
      dispatch(limpiarFiltros())
      dispatch(setBusqueda(''))
      dispatch(setFamiliaSeleccionada(estadistico_url, familia_url, ''))
      dispatch(
        anadirFiltro({
          estadistico: estadistico_url,
          familia: familia_url,
          nombre: '',
          tipo: 'estad',
        }),
      )
    }

    if (
      filtros === undefined ||
      filtros.filtros === undefined ||
      filtros.filtros.length === 0 ||
      filtros_claves_estadisticas === undefined ||
      filtros_claves_estadisticas.filtros_claves_estadisticas === undefined ||
      filtros_claves_estadisticas.filtros_claves_estadisticas.length === 0
    ) {
      dispatch(getFiltros())
    }
  }, [])

  useEffect(() => {
    window.wookie()
  })

  const cambiarBuscador = () => {
    if (buscador === 'basico') {
      setBuscador('avanzado')
    } else {
      setBuscador('basico')
    }
  }

  // Partimos la URL
  let url = window.location.pathname
  let splittedURL = url.split('/')
  // Cogemos el codigo_articulo
  if (splittedURL[2] && splittedURL[3] && splittedURL[4]) {
    estadistico_url = splittedURL[2]
    familia_url = splittedURL[3]
    descrip_url = splittedURL[4]
  }

  return (
    <div className='listado-articulos'>
      <FamiliasMenu />
      <div style={{ width: '100%' }}>
        {buscador === 'basico' ? (
          <Buscador
            cambiarBuscador={cambiarBuscador}
            mostrar_avanzado={ecom_parametros?.bus_avanz === 'S'}
          />
        ) : (
          <BuscadorAvanzado cambiarBuscador={cambiarBuscador} />
        )}
        <div className='container-listado-articulos container'>
          <div
            id='tt-pageContent'
            className='articulos'>
            <div className='container-indent'>
              <div className='container-fluid-custom container-fluid-custom-mobile-padding'>
                <div
                  className='row'
                  style={{ flexDirection: 'row-reverse' }}>
                  <ArticulosFiltros />
                  <div className='col-md-12 col-lg-9 col-xl-9'>
                    <ListadoArticulos
                      origen='articulos'
                      mostrar='lista'
                      filtro_url={
                        estadistico_url && familia_url && descrip_url
                          ? {
                              estadistico: estadistico_url,
                              familia: familia_url,
                              nombre: descrip_url,
                            }
                          : null
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Articulos
